// Import controller interfaces
import {
    IPropertyController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    Address,
    AddressVerification,
    GpsCoordinatesWithAccuracy,
    PossibleState,
    ThirdPartyPropertyDataCommercial,
    ThirdPartyPropertyDataPersonal
} from '@app/models/api';

export default class MockPropertyController implements IPropertyController {

    public constructor() {

    }

    public async verifyAddress(addressLine1: string,
        addressLine2: string,
        city: string,
        state: string,
        postalCode: string): Promise<AddressVerification> {

        throw new Error("Method not implemented.");
    }

    public async verifySingleLineAddress(address: string): Promise<AddressVerification> {
        throw new Error("Method not implemented.");
    }

    public async geocodeAddress(addressLine1: string,
        addressLine2: string,
        city: string,
        state: string,
        postalCode: string): Promise<GpsCoordinatesWithAccuracy> {

        throw new Error("Method not implemented.");
    }

    public async getAddressSuggestions(address: string): Promise<Address[]> {
        throw new Error("Method not implemented.");
    }

    public async getStates(): Promise<PossibleState[]> {
        throw new Error("Method not implemented.");
    }

    public async getThirdPartyPropertyDataCommercial(address: string, city: string, state: string, postalCode: string, lat: number, lng: number): Promise<ThirdPartyPropertyDataCommercial> {
        throw new Error('Method not implemented.');
    }

    public async getThirdPartyPropertyDataPersonal(addressLine1: string, addressLine2: string, city: string, state: string, postalCode: string, lat: number, lng: number): Promise<ThirdPartyPropertyDataPersonal> {
        throw new Error('Method not implemented.');
    }
};